$(document).ready(function() {
    menu_main();
  });

  var $main_menu = $('#block-accessible-main-menu'),
      $submenu_toggles = $('.subnav-trigger'),
      $html = $('html'),
      $mobileMenu = $('.menu-main-toggle'),
      $subnavs = $('.main-menu__submenu--container--inner > .main-menu__list--subnav');


          



  // main menu
  function menu_main() {
    // adjusts the height of submenu lists
    $subnavs.each(function() {
      var tallChild = false;

      $(this).find('.main-menu__list--subnav').each(function() {
        if ( $(this).find('.main-menu--item--subnav').length > 7 ) {
          tallChild = true;
        }
      });

      if ( !$(this).prev('.main-menu-left-col').length && tallChild == false ) {
        $(this).height('auto');
      } 
    });

    $submenu_toggles.parent().parent()
      .attr('aria-haspopup', true)
      .attr('aria-expanded', false);

    $submenu_toggles.on('click', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      // desktop
      if ( $mobileMenu.css('display') == 'none' ) {
        // if it's not already active
        if ( !$(this).parent().parent().hasClass('submenu--revealed') ) {
          // Close active items
          // level 1
          if ( !$(this).parents('.main-menu__list--subnav').length ) {
            $main_menu.find('.submenu--revealed').removeClass('submenu--revealed').attr('aria-expanded', false);
            $main_menu.find('.main-menu--item--combo + .active').removeClass('active').hide();
          }
          // level 2
          else {
            $('.main-menu--item--subnav.submenu--revealed').removeClass('submenu--revealed').attr('aria-expanded', false);
            $('.main-menu__list--subnav.active').removeClass('active').hide();
          }

          // Open this subnav
          $(this).parent().parent()
            .attr('aria-expanded', true)
            .addClass('submenu--revealed');

          if ( $(this).parent().next('.main-menu__submenu--container').length ) {
            $(this).parent().next('.main-menu__submenu--container').show().addClass('active');  
          }
          else {
            $(this).parent().next('.main-menu__list--subnav').show().addClass('active');
          }
        }

        // if it's active
        else {
          $(this).parent().parent()
            .attr('aria-expanded', false)
            .removeClass('submenu--revealed');

          if ( $(this).parent().next('.main-menu__submenu--container').length ) {
            $(this).parent().next('.main-menu__submenu--container').hide().removeClass('active');  
          }
          else {
            $(this).parent().next('.main-menu__list--subnav').hide().removeClass('active');
          }
        }
      }
      // mobile
      else {
        if ( !$(this).parent().parent().hasClass('submenu--revealed') ) {
          $(this).parent().parent()
            .attr('aria-expanded', true)
            .toggleClass('submenu--revealed');

          $html.addClass('submenu-is-open');
          if ( $(this).parent().next('.main-menu__submenu--container').length ) {
            $(this).parent().next('.main-menu__submenu--container').slideDown();
          }
          else {
            $(this).parent().next('.main-menu__list--subnav').slideDown();
          }
        }
        else {
          $(this).parent().parent()
            .attr('aria-expanded', false)
            .toggleClass('submenu--revealed');

          $html.removeClass('submenu-is-open');
          if ( $(this).parent().next('.main-menu__submenu--container').length ) {
            $(this).parent().next('.main-menu__submenu--container').slideUp();
          }
          else {
            $(this).parent().next('.main-menu__list--subnav').slideUp();
          }
        }
      }
    });
  }